import story_BG from '../Assets/Imgs/BandBG00.jpg';

import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';
import SongCard from '../Components/SongCard';

function Info() {
  return (
    <div className="App">
      <div className="Info-header">
        <NavBar />
        <img src={story_BG} className="story-bg-img" />
        <div className="story-bg info-bg">
          <div className="headerFade">
            <p className="">No AI Policy</p>
          </div>
          <div className="row spaceAround">
            <p className="rowBlock blockWhite" >Zeroz absolutely forbids anyone from using Zeroz music in any and all AI training data & datasets.</p>
            <p className="rowBlock blockWhite" >Zeroz also refuses to use AI in any way shape or form in Zeroz art & music, including coding.</p>
          </div>
            <p className="letterSpacing infoContactHeader">Contact</p>
          <p className="blockWhite" style={{margin: 0}}>All of Zeroz is written and created by Aidan Christopher Haughey<br/> Email ah@sied.online for contact, or message on IG || Tik Tok</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Info;
